import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function challenge() {
  return (
    <section className="challenge_par p-100 text_color">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Challenges & <span>Solutions</span>
            </h2>
            <p>
              While taking on the project, the biggest challenge we had was
              building a board game similar to Parcheesi (Ludo) but with
              increased multiplayer capacity from four players to six players –
              and that too without drifting away from the real essence of the
              game.
            </p>
            <p>
              Moreover, hundreds of similar games have been on the market, so we
              had to integrate certain features to captivate the audience and
              bring them to our platform. So, we tweaked the rules and blended
              them with the perfect mix of the Spanish and Indian Classic rules.
              We further integrated leaderboards, profile customization, in-game
              messaging, friend’s portal, and board customization features to
              make it stand out from the other games available.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-2 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/parcheesi/challenge_main.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={528}
                height={519}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default challenge;
